import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column justify-space-between full-height" }
const _hoisted_2 = { class: "text-end" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " Crée le ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Créer un sondage", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_title = _resolveComponent("app-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_notification = _resolveComponent("notification")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "full-height"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        justify: "space-between",
        align: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "3",
            class: "mt-md-10 pl-md-12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_app_title, { title: "Mes sondages" })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "5",
            xl: "4",
            class: "mt-md-10 d-flex justify-end pr-md-10 align-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                "prepend-icon": "mdi-plus",
                color: "grey-darken-4",
                onClick: _ctx.openDialogCreation
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Ajouter un sondage ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.getPollsBySearch.length > 0)
        ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_pagination, {
                modelValue: _ctx.pollsPaginated.page,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pollsPaginated.page) = $event)),
                  _ctx.onPaginationChange
                ],
                length: _ctx.pollsPaginated.totalPages
              }, null, 8, ["modelValue", "length", "onUpdate:modelValue"])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_notification, {
                    message: "Vous n'avez pas encore créé de sondage",
                    permanent: "",
                    closable: false,
                    "min-width": 1000,
                    "min-height": 50,
                    type: _ctx.NotificationType.INFO
                  }, null, 8, ["type"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })),
      (_ctx.getPollsBySearch.length > 0)
        ? (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPollsBySearch, (poll, index) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: index,
                  cols: "12",
                  md: "4",
                  class: "pa-5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "pa-5",
                      height: "100%",
                      onClick: ($event: any) => (_ctx.onPollRedirect(poll))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                          _createElementVNode("div", null, [
                            _createElementVNode("h2", null, _toDisplayString(poll.name), 1),
                            _createElementVNode("p", null, _toDisplayString(poll.description), 1)
                          ]),
                          _createElementVNode("p", _hoisted_2, [
                            _hoisted_3,
                            _createTextVNode(),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formatLocaleDateTime(poll.createDate)), 1)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_dialog, {
        width: "1000",
        fullscreen: _ctx.$vuetify.display.mobile,
        modelValue: _ctx.isCreatingPoll,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isCreatingPoll) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            width: "100%",
            class: "align-self-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6",
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.pollToCreate.name,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pollToCreate.name) = $event)),
                            label: "Titre",
                            required: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_textarea, {
                            modelValue: _ctx.pollToCreate.description,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pollToCreate.description) = $event)),
                            label: "Description",
                            required: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_file_input, {
                            modelValue: _ctx.fileToUpload,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.fileToUpload) = $event)),
                            onChange: _ctx.onFileUpload,
                            accept: "image/*",
                            label: "Photo du sondage"
                          }, null, 8, ["modelValue", "onChange"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6",
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_date_picker, {
                        modelValue: _ctx.pollToCreate.limitDate,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pollToCreate.limitDate) = $event)),
                        min: _ctx.minDateEqualsNow
                      }, null, 8, ["modelValue", "min"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isCreatingPoll = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Annuler")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    color: "success",
                    variant: "flat",
                    onClick: _ctx.createPoll
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Créer le sondage")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["fullscreen", "modelValue"])
    ]),
    _: 1
  }))
}